module.exports = __webpack_public_path__ + "media/images/extension-onboarding/select-a-publication-b10f571b44f68b3a1f4277dc92004f32.png";